<template>
    <div :class="['dimmer' , loading ?  'active' : '']">
        <div class="loader"></div>
        <div class="dimmer-content">
            <div>
                <div class="row">
                    <div class="col-12 col-sm-6">
                        <div class="form-group">
                            <label>First Name</label>
                            <div><strong>{{ model.name }}</strong></div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6">
                        <div class="foOpenrm-group">
                            <label>Last Name</label>
                            <div><strong>{{ model.last_name }}</strong></div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-sm-6">
                        <div class="form-group">
                            <label>Email</label>
                            <div><strong>{{ model.email }}</strong></div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6">
                        <div class="form-group">
                            <label>Phone</label>
                            <div><strong>{{ model.phone }}</strong></div>
                        </div>
                    </div>
                </div>

                <div class="col-12 px-0">
                    <h3 class="text-5 font-weight-400 mt-3">Permissions</h3>
                    <hr>
                </div>

                <div class="col-12 px-4 pb-4">
                    <div v-for="permission in model.permissions" class="">
                        <label class="col-form-label" :for="`permissions-${permission.id}`">
                          <i class="fas fa-check-circle text-success"></i>  You can "{{ permission.name.replace('-', ' ') }}"
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "Index",
    data() {
        return {
            loading: false,
            model: {
                permissions: []
            },
        };
    },

    mounted() {
        this.init();
    },

    methods: {
        init() {
            this.loading = true;
            window.axios.get(`/business/profile/api`).then((response) => {
                this.model = response.data.body.model;
                this.loading = false;
            });
        },
    }
}
</script>

<style scoped>

</style>
